import { Blade, BladeLevel } from '@nrdy-marketing-engine/dropdown-menu';
import clsx from 'clsx';

interface NavigationProps {
  className?: string;
  currentBlade?: string;
  menu: NavigationMenu;
  toggleBlade: (key, event) => void;
}

interface NavigationListItemProps extends Omit<NavigationProps, 'menu'> {
  bladeClassName?: string;
  item: NavigationRoot;
  tag?: keyof JSX.IntrinsicElements;
}

const LINK_CLASSES =
  'text-sm whitespace-nowrap hover:text-link dark:hover:text-white dark:hover:underline dark:text-base';

export function NavigationRootItem({
  item,
  toggleBlade,
  currentBlade,
  className,
  bladeClassName,
  tag: Tag = 'li',
}: NavigationListItemProps) {
  const isOpen = currentBlade === item.text;
  const linkClassName = clsx(LINK_CLASSES, isOpen && 'text-link dark:text-white');
  const spanClassName = clsx(item.items && 'block dropdown-arrow', isOpen && 'dropup-arrow');
  const onClick = item.items ? toggleBlade.bind(this, item.text) : undefined;

  return (
    <Tag className={clsx(item.items && 'relative', className) || null}>
      <a className={linkClassName} href={item.href || '#'} onClick={onClick}>
        {spanClassName ? <span className={spanClassName}>{item.text}</span> : item.text}
      </a>
      {item.items && (
        <Blade className={clsx('flex', bladeClassName)} rollup visible={isOpen}>
          <BladeLevel items={item.items} />
        </Blade>
      )}
    </Tag>
  );
}

export default function Navigation({
  currentBlade,
  toggleBlade,
  className,
  menu,
}: NavigationProps) {
  const { navigation } = menu;
  return (
    <ul className={clsx('items-center space-x-4 2xl:space-x-6', className)}>
      {Object.entries(navigation)
        .filter((item) => item[0] !== 'logo_member')
        .map(([key, item]) => (
          <NavigationRootItem
            currentBlade={currentBlade}
            item={item}
            key={key}
            toggleBlade={toggleBlade}
          />
        ))}
    </ul>
  );
}
